import Layout from '@layout';
import { getStoreLocations } from '@core_modules/storelocator/services/graphql';
import Content from '@core_modules/storelocator/pages/default/components';
import { useRouter } from 'next/router';

const PageStoreLocator = (props) => {
    const { t } = props;

    const [titlePage, setTitlePage] = React.useState('');
    const config = {
        title: `${t('storelocator:title')} ${titlePage ? `| ${titlePage}` : ''}`,
        header: 'relative', // available values: "absolute", "relative", false (default)
        headerTitle: t('storelocator:title'),
        bottomNav: false,
        tagSelector: 'swift-page-storelocator',
    };
    const { data, loading } = getStoreLocations();

    const route = useRouter();
    const isEngraving = route?.query?.engraving === '1';
    const storeUrlKey = route?.query?.store;

    const initDataStore = {
        meta_description: t('storelocator:title'),
        meta_title: t('storelocator:title'),
        meta_keywords: t('storelocator:title'),
    };
    const [dataStore, setDataStore] = React.useState(initDataStore);

    const handleGetMetadataStore = (metadata) => {
        const metadataStore = metadata || initDataStore;
        setTitlePage(metadata?.meta_title || '');
        setDataStore(metadataStore);
    };

    return (
        <Layout
            {...props}
            pageConfig={config}
            data={dataStore}
            isStoreLocator
        >
            <Content
                t={t}
                loading={loading}
                storeLocations={data && data.storeLocation && data.storeLocation.items}
                isEngraving={isEngraving}
                storeUrlKey={storeUrlKey}
                handleGetMetadataStore={handleGetMetadataStore}
                {...props}
            />
        </Layout>
    );
};

export default PageStoreLocator;
